import React from "react";
import useMovieTrailer from "../hooks/useMovieTrailer";

const VideoBackground = ({ movieId }) => {
	const { trailerVideo, loading, error } = useMovieTrailer(movieId);

	// Show error state
	if (error) {
		return (
			<div className="movie-video-wrapper">
				<div className="relative movie-video h-[56.25vw] max-h-screen overflow-hidden bg-gray-900 flex items-center justify-center">
					<div className="text-red-500 text-xl">Failed to load trailer</div>
				</div>
			</div>
		);
	}

	return (
		<div className="movie-video-wrapper">
			<div className="relative movie-video h-[56.25vw] max-h-screen overflow-hidden">
				<iframe
					src={`https://www.youtube.com/embed/${trailerVideo?.key}?autoplay=1&mute=1&loop=1&playlist=${trailerVideo?.key}&modestbranding=1&controls=0&showinfo=0`}
					title="YouTube video player"
					className="absolute top-0 left-0 w-full h-full scale-150 object-cover pointer-events-none"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
				></iframe>
			</div>
		</div>
	);
};

export default VideoBackground;
